import { Auth } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';

import ReactRoot from './ReactRoot';
import env from './env';
import { datadogLogs, datadogRum } from './logging/datadog';
import './tailwind.css';
import CustomAmplifyStorage from './util/customAmplifyStorage';
import getAppVersion from './util/getAppVersion';
import './v2/styles/theme.css';

console.log('version: ', getAppVersion());
console.log('env: ', env.NODE_ENV, process.env.NODE_ENV);

// Configure custom storage to share User Pool tokens via cookies
// while keeping Identity Pool credentials in localStorage
const cookieConfig = {
  domain: env.REACT_APP_COOKIE_DOMAIN || window.location.hostname.split('.').slice(-2).join('.'),
  path: '/',
  expires: 30,
  secure: window.location.protocol === 'https:',
  sameSite: 'lax',
};

const customStorage = new CustomAmplifyStorage(cookieConfig);

Auth.configure({
  // REQUIRED - Amazon Cognito Identity Pool ID
  identityPoolId: env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  // REQUIRED - Amazon Cognito Region
  region: env.REACT_APP_AWS_COGNITO_REGION,
  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolWebClientId: env.REACT_APP_AWS_COGNITO_USER_POOL_WEBCLIENT_ID,
  oauth: {
    domain: env.REACT_APP_AWS_OAUTH_DOMAIN,
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNIN,
    redirectSignOut: env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNOUT,
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  // Use custom storage for cross-app authentication via cookies
  storage: customStorage,
});

if (env.REACT_APP_DATADOG_RUM_ENABLED) {
  datadogRum.get().catch(console.error);
} else {
  console.log('DATADOG RUM disabled');
}

if (env.REACT_APP_DATADOG_LOG_ENABLED) {
  datadogLogs.get().catch(console.error);
} else {
  console.log('DATADOG LOGS disabled');
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<ReactRoot />);
